import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
           /* {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuard]
            },
            {
                path: 'author-analytics',
                loadComponent: () => import('./features/author-analytics/author-analytics.component')
                    .then(m => m.AuthorAnalyticsComponent)
            },            
            {
                path: 'campaign-performance',
                loadComponent: () => import('./features/campaign/campaign-performance/campaign-performance.component')
                    .then(m => m.CampaignPerformanceComponent),
                title: 'Campaign Performance'
            },
            {
                path: 'hum-campaigns',
                loadComponent: () => import('./features/campaign/hum-campaigns/hum-campaigns.component')
                    .then(m => m.HumCampaignsComponent),
                title: 'HUM Campaigns'
            }*/
        ]
    },
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'profile-analytics',
        loadComponent: () => import('./features/profile-analytics/profile-analytics.component').then(m => m.ProfileAnalyticsComponent),
        title: 'Profile Analytics'
    },
    // Catch-all redirect to dashboard
    {
        path: '**',
        redirectTo: 'dashboard'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
